import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 22px;
  color: #444;
  font-weight: 600;
  margin-bottom: 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Content = styled.div`
  flex: 1;
  margin-right: 30px;
`;

export const SideBar = styled.div`
  width: 416px;
`;

export const EmptyAlerts = styled.div`
  height: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbbbbb;
  font-size: 18px;
  margin-top: -32px;

  div {
    text-align: center;
    max-width: 400px;
  }
`;
